// The search box. It commits 900ms after the last edit, or immediately on Enter.

import React, { useEffect, useRef } from 'react'

import { useTable } from '../context'
import { ACTIONS } from '../types'

export const SEARCH_DEBOUNCE_MS = 900

const commit = value => ({
  type: ACTIONS.searchCommit,
  value,
  reason: 'search',
})

// Called by the shell, so a pending commit outlives the box being hidden. Returns the box's handlers.
export const useSearchDebounce = (state, dispatch) => {
  const timer = useRef(null)
  const draft = state.searchDraft

  useEffect(() => () => clearTimeout(timer.current), [])

  return {
    onChange: event => {
      const value = event.target.value
      dispatch({ type: ACTIONS.searchDraft, value, reason: 'search' })
      clearTimeout(timer.current)
      timer.current = setTimeout(
        () => dispatch(commit(value)),
        SEARCH_DEBOUNCE_MS
      )
    },
    onKeyDown: event => {
      if (event.key === 'Enter') {
        event.preventDefault()
        clearTimeout(timer.current)
        dispatch(commit(draft))
      }
    },
    cancel: () => clearTimeout(timer.current),
  }
}

export const Search = () => {
  const { config, state, search } = useTable()
  return (
    <span className="me-search-field">
      <i className="fa-regular fa-magnifying-glass" aria-hidden="true" />
      <input
        type="search"
        aria-label={config.searchLabel || 'Search'}
        placeholder={config.searchPlaceholder}
        value={state.searchDraft}
        onChange={search.onChange}
        onKeyDown={search.onKeyDown}
      />
    </span>
  )
}
